module.exports = __webpack_public_path__ + "img/67200.f5fea478.jpg";